export default ({ COLORS }) => ({
  group: {
    margin: '15px 0 0',
    '&:first-child': {
      margin: '0'
    }
  },
  noGroups: {
    color: COLORS.TEXT.MID_GREY.NORMAL,
    height: '40px',
    display: 'flex',
    alignItems: 'center'
  }
})
